// Thread's house template for manual USD invoices (Keynes and any other USD
// client; GBP / NZD invoices go through Xero). Ported from the
// `thread-invoice` skill's generate_invoice.py, which stays the source of
// truth for layout: docs/invoice/generate_invoice.py. Typeface is Obviously
// (Thread's house face; Obviously SemiBold for labels). Colours are the Hub's
// theme tokens (theme.js): primary olive for body, secondary olive for the
// sender and payment blocks, pine for labels and totals. No mid greys.
//
// These are the invoice template's own colours, not the Hub UI palette, so
// they live here rather than in theme.js.
export const INVOICE_COLOURS = {
  pine: "1F4A3D",     // table header, totals
  band: "B1D6B3",     // light-green strip across the top
  greyText: "2E3105", // secondary blocks (company, payment): the same olive as the body; nothing on the page is lighter than body text (Alex, 30 Oct 2026)
  body: "2E3105",     // body text: the Hub's primary olive (theme.js root), near black
  darkLabel: "2E3105",// bold field labels
  black: "000000",
  altFill: "F6F6F0",  // zebra on alternating line-item rows (warm, like the Hub's mist)
  white: "FFFFFF",
};
export const INVOICE_FONT = "Obviously";
export const INVOICE_FONT_BOLD = "Obviously SemiBold";
// Display roles (title, labels, group headings, totals): Obviously Bold, embedded
// in the print page (src/invoice/obviouslyBold.js). Body text: Poppins from Google
// Fonts, the Hub face and the brand kit's heading face, until a Regular or
// SemiBold Obviously is supplied (30 Oct 2026: only Bold and Black weights exist).
export const INVOICE_FONT_STACK = "Obviously, Poppins, 'Helvetica Neue', Arial, sans-serif";
export const INVOICE_BODY_STACK = "Poppins, 'Helvetica Neue', Arial, sans-serif";
export const USD_FORMAT = '"$"#,##0.00';
export const DATE_FORMAT = "d mmm yyyy";

// Excel column widths; A and I are narrow side margins.
export const COLUMN_WIDTHS = { A: 6.1, B: 23.1, C: 34.2, D: 10.0, E: 4.9, F: 16.0, G: 14.5, H: 13.1, I: 6.1 };

// Constant for every USD invoice. The sender address is an editable default:
// 16 Achilles Crescent since Sept 2026 (INV-KD-371); earlier invoices used
// 89 Albert Road, Devonport.
export const FROM_DEFAULT = {
  entity: "People Performance Partners Ltd, trading as Thread",
  address: "16 Achilles Crescent\nNarrow Neck\nAuckland 0624\nNew Zealand",
  contact: "alex@teamthread.co",
  website: "teamthread.co",
};
export const PAYMENT_TERMS = "Payment due in full in advance of the service period.";
export const PAYMENT_DEFAULT = [
  ["Transfer Type", "International SWIFT transfer in USD"],
  ["Name", "PEOPLE PERFORMANCE PARTNERS LIMITED"],
  ["Account No.", "17992440"],
  ["Sort Code", "23-14-70"],
  ["IBAN", "GB97TRWI23147017992440"],
  ["SWIFT/BIC", "TRWIGB2LXXX"],
  ["Bank name and address:", "Wise Payments Limited, 56 Shoreditch High Street, London, E1 6JJ, United Kingdom"],
];
export const FOOTER = "Thread is incorporated in New Zealand as People Performance Partners Ltd (9429052287169)";

// Grid anchors from the reference script.
export const HEADER_ROW = 21;

// Line item groups, in the order they print. Each line carries `kind`.
export const LINE_KINDS = [["base", "Monthly retainer"], ["addition", "Retainer additions"], ["oneoff", "This month's one-offs"]];
export const kindOf = li => (LINE_KINDS.some(([k]) => k === li.kind) ? li.kind : "oneoff");
export const LOGO_SIZE = { width: 185, height: 66 };
